'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');

var ToggleSwitch = function (props) {
    var _a = props.name, name = _a === void 0 ? 'toggleswitch' : _a, onToggleClick = props.onToggleClick, _b = props.initialCheck, initialCheck = _b === void 0 ? true : _b, checked = props.checked, _c = props.disabled, disabled = _c === void 0 ? false : _c, _d = props["data-testid"], dataTestId = _d === void 0 ? 'toggle-switch' : _d, color = props.color;
    var isControlledByParent = checked !== undefined;
    var _e = React__default.useState(initialCheck), state = _e[0], setState = _e[1];
    var getChecked = function () {
        if (isControlledByParent) {
            return checked;
        }
        return state;
    };
    var handleChange = function () {
        if (!disabled) {
            if (!isControlledByParent)
                setState(!state);
            onToggleClick(isControlledByParent ? !checked : !state);
        }
    };
    return (React__default.createElement(styledComponents.StyledSwitch, { "data-testid": dataTestId, checked: getChecked(), onClick: handleChange, name: name, customColor: color, disabled: disabled, inputProps: {
            'aria-label': 'primary checkbox',
            'data-testid': dataTestId + "-checkbox",
        } // data-testid isnt on this props list but works
     }));
};

module.exports = ToggleSwitch;
